import React, { useEffect } from 'react';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../styles/booking-embed.css';

const BookBungeePage = () => {
  useEffect(() => {
    // Load Acuity embed script
    const script = document.createElement('script');
    script.src = 'https://embed.acuityscheduling.com/js/embed.js';
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://embed.acuityscheduling.com/js/embed.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="booking-embed-page">
      <div className="booking-embed-header">
        <Link to="/bungee" className="back-link">
          <ArrowLeft size={20} />
          Back to Bungee Fitness
        </Link>
        <h1 className="booking-embed-title">Book Bungee Fitness</h1>
        <p className="booking-embed-subtitle">
          Select your class, pick a time, and get ready to fly.
        </p>
      </div>

      <div className="booking-embed-container" data-testid="acuity-embed-container">
        <iframe 
          src="https://app.acuityscheduling.com/schedule.php?owner=37343334&ref=embedded_csp" 
          title="Schedule Appointment" 
          width="100%" 
          height="800" 
          frameBorder="0" 
          allow="payment"
          className="booking-embed-iframe acuity-iframe"
        />
      </div>

      <div className="booking-embed-fallback">
        <p>Having trouble?</p>
        <a 
          href="https://app.acuityscheduling.com/schedule.php?owner=37343334&ref=booking_button" 
          target="_blank" 
          rel="noopener noreferrer"
          className="fallback-link"
        >
          Open booking page in a new tab
          <ExternalLink size={16} />
        </a>
      </div>
    </div>
  );
};

export default BookBungeePage;
